import styled from 'styled-components';

const SalesJetpackContainer = styled.div`
  margin-top: 100px;
`;

const SalesJetpackHeader = styled.div`
  padding: 10px 20px;
  font-size: 20px;
  font-weight: 700;
  color: #000000;
  background-color: #ededed;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px;
`;

const SalesJetpackInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: auto;
`;

const SalesPitchCompanyData = styled.div`
  flex: 2;
  border-right: 1px solid #d0d0d0;
  flex-direction: column;
  padding: 9px 20px;
`;

const SeparatorText = styled.span`
  margin: 0 10px;
  font-weight: 700;
`;

const SalesPitchFor = styled.div`
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 16px;
`;

const SalesPitchTrainingData = styled.div`
  flex: 3;
  flex-direction: column;
  padding: 20px;
  overflow-x: auto;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CompanyName = styled.div`
  width: max-content;
  background-color: #d9e8ec;
  color: #000000;
  border-radius: 5px;
  padding: 10px;
  font-weight: 700;
`;

const CompanyTags = styled.div`
  width: max-content;
  background-color: #cbf2d7;
  color: #000000;
  border-radius: 5px;
  padding: 10px;
  font-weight: 700;
  margin-right: 15px;
`;

const CustomSectionContainer = styled.div`
  max-width: 200px
  margin-bottom: 50px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  width: max-content;
`;

const CustomSectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const CustomSectionVideo = styled.div`
  width: ${props => (props.smallSection ? '150px' : '200px')};
  height: ${props => (props.smallSection ? '130px' : '180px')};
  background-color: #efefef;
  border-radius: 5px;
  box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
  cursor: pointer;
`;

const CustomSectionSubtitle = styled.div`
  width: ${props => (props.smallSection ? '150px' : '200px')};
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
`;

const ExtraDataSection = styled.div`
  margin: 20px 0px 10px;
  display: flex;
  flex-direction: column;
`;

const ExtraDataContent = styled.div`
  margin: 0px 0px 5px;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`;

const ExtraDataTitle = styled.div`
  margin: 0px 0px 10px;
  font-size: 16px;
  font-weight: 700;
  color: ${props => (props.green ? '#761e1e' : '#018d2a')};
`;
const TemplateData = styled.div`
  margin: 50px 0px 10px;
  font-size: 16px;
  p {
    margin: 20px 0px;
  }
  ol {
    margin-left: 20px;
    li {
      margin: 20px 0px;
    }
  }
`;

const DemoList = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

export default {
  SalesJetpackContainer,
  SalesJetpackHeader,
  SalesJetpackInfoContainer,
  SalesPitchCompanyData,
  SeparatorText,
  SalesPitchFor,
  SalesPitchTrainingData,
  CompanyInfo,
  CompanyName,
  CompanyTags,
  CustomSectionContainer,
  CustomSectionTitle,
  CustomSectionVideo,
  CustomSectionSubtitle,
  ExtraDataSection,
  ExtraDataContent,
  ExtraDataTitle,
  LoaderContainer,
  TemplateData,
  DemoList
};



// WEBPACK FOOTER //
// ./src/pages/SalesJetpack/styles.js